module.exports = __webpack_public_path__ + "img/52.a9d46173.png";